import React from 'react'
import BaseLayout from '../components/BaseLayout/BaseLayout'
import GameflowLayout from '../components/GameflowLayout'
import { useDocumentTitle } from '../hooks/setDocumentTitle'

export default function Gameflow() {
  useDocumentTitle('Gameflow');
  return (
    <div className='gameflow'>
        <BaseLayout>
            <GameflowLayout />
        </BaseLayout>
    </div>
  )
}
